import {
  FETCH_ORDER_STATUS_MAP_START,
  FETCH_ORDER_STATUS_MAP_SUCCESS,
  FETCH_ORDER_STATUS_MAP_FAIL,
  UPDATE_ORDER_STATUS_MAP_SUCCESS,
} from './action';
import { ORDER_STATUS_AXES } from '../../constants/order-status-triggers.constants';

const emptyAxisState = { data: null, isLoading: false, err: null };

const initialState = {
  byAxis: {
    [ORDER_STATUS_AXES.ORDER]: { ...emptyAxisState },
    [ORDER_STATUS_AXES.FULFILLMENT]: { ...emptyAxisState },
  },
};

const updateAxis = (state, axis, patch) => ({
  ...state,
  byAxis: {
    ...state.byAxis,
    [axis]: {
      ...(state.byAxis[axis] || emptyAxisState),
      ...patch,
    },
  },
});

export default (state = initialState, action = {}) => {
  const { type, axis, payload } = action;
  switch (type) {
  case FETCH_ORDER_STATUS_MAP_START:
    return updateAxis(state, axis, { isLoading: true, err: null });
  case FETCH_ORDER_STATUS_MAP_SUCCESS:
    return updateAxis(state, axis, { data: payload, isLoading: false });
  case FETCH_ORDER_STATUS_MAP_FAIL:
    return updateAxis(state, axis, { err: payload, isLoading: false });
  case UPDATE_ORDER_STATUS_MAP_SUCCESS:
    return updateAxis(state, axis, { data: payload });
  default:
    return state;
  }
};
